// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ele-table-editor .el-form-item{margin-bottom:0;display:inline-block}.ele-table-editor-content{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ele-table-editor-btn{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
